import { Reveal, Chapter } from "./Reveal";

const TENANTS = [
  { id: "A", name: "Island Craft DMC", market: "Maldives · USD" },
  { id: "B", name: "Golden Triangle Tours", market: "India · INR" },
  { id: "C", name: "Emirates Gate Travel", market: "UAE · AED" },
  { id: "D", name: "Mekong & Co.", market: "Vietnam · VND" },
];

const OWNS = ["Own domain", "Own branding", "Own content", "Own customers", "Own packages", "Own inquiries"];

export default function MultiTenant() {
  return (
    <section className="border-y border-sand bg-parch py-24 lg:py-28" data-testid="multitenant-section">
      <div className="container-x">
        <Reveal><Chapter index={5} label="Architecture" /></Reveal>
        <div className="mt-8 grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <h2 className="font-serif text-3xl leading-[1.15] tracking-tight text-ink sm:text-4xl">
              Your Business. Your Brand. Your Data.
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-stone2">
              Travel-Tek provides the technology infrastructure while each DMC
              operates within its own branded environment.
            </p>
            <div className="mt-7 flex flex-wrap gap-1.5">
              {OWNS.map((o) => (
                <span key={o} className="rounded-full border border-sand bg-white px-3 py-1.5 text-xs font-semibold text-ink">{o}</span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.12} className="lg:col-span-7">
            <div className="rounded-2xl border border-sand bg-white p-5 sm:p-7">
              <div className="rounded-xl bg-ink p-5 text-center">
                <p className="font-serif text-xl text-paper">Travel-Tek Platform</p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-terra">Managed infrastructure · one engine</p>
              </div>
              <div className="mx-auto h-6 w-px bg-sand" />
              <div className="grid gap-3 sm:grid-cols-2">
                {TENANTS.map((t, i) => (
                  <Reveal key={t.id} delay={0.08 * i}>
                    <div className="rounded-xl border border-sand bg-paper p-4 transition-all duration-300 hover:-translate-y-1 hover:border-terra/50" data-testid={`tenant-card-${t.id.toLowerCase()}`}>
                      <div className="flex items-center justify-between">
                        <p className="text-sm font-bold text-ink">{t.name}</p>
                        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-terra/15 font-mono text-[10px] font-bold text-terra">{t.id}</span>
                      </div>
                      <p className="mt-1 font-mono text-[10px] uppercase tracking-wider text-stone2">{t.market}</p>
                      <p className="mt-2 text-[11px] text-stone2">yourdmc-{t.id.toLowerCase()}.com · own brand · own data</p>
                    </div>
                  </Reveal>
                ))}
              </div>
              <p className="mt-5 text-center text-xs text-stone2">
                Each DMC gets its own digital environment while Travel-Tek manages the technology underneath.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
